/* var ws_address = "fs.kunlitop.com" , ws_port = "7443" ; */
// var ws_address = 'mazhenhua' , ws_port = "7443" ;
/* eslint-disable */
let ws_address = '121.4.165.94',
  ws_port = '7443';
let account = '';
let called = '';
let softPhoneUA,
  currentSession,
  mediaStream;


function setParam() {
  ws_address = 'wss.fengyantop.com';
}
// 签入
function registerButton() {
  SipjsSoftPhone.ready();
}
// 呼叫
function makecallButton(callnum) {
  SipjsSoftPhone.invite(callnum);
}
// 挂机
function hangupButton() {
  SipjsSoftPhone.hangup();
}


function setButtonUseable(buttonId) {
  document.getElementById(buttonId).disabled = false;
  document.getElementById(buttonId).className = buttonId;
}

function setButtonDisabled(buttonId) {
  document.getElementById(buttonId).disabled = true;
  document.getElementById(buttonId).className = buttonId + '-disabled';
}

function setButtonDisplayNone(buttonId) {
  document.getElementById(buttonId).style.display = 'none';
}

function setButtonDisplayBlock(buttonId) {
  document.getElementById(buttonId).style.display = 'block';
}


function two_char(n) {
  return n >= 10 ? n : '0'+n;
}

var timer;
function time_run() {
  var sec = 0;
  timer = setInterval(function () {
      sec ++;
      var date = new Date(0, 0);
      date.setSeconds(sec);
      var h = date.getHours(), m = date.getMinutes(), s = date.getSeconds();
      document.getElementById('calltime').innerHTML = two_char(h) + ':' + two_char(m) + ':' + two_char(s);
  }, 1000);
}
function time_stop() {
  clearInterval(timer);
}


var SipjsSoftPhone = {
  getOptions() {
    const options = {
      media: {
        constraints: {
          audio: true,
          video: false
        },
        render: {
          remote: document.getElementById('remoteAudio'),
          local: document.getElementById('localAudio')
        }
      }
    };
    return options;
  },

  login(extno, extpass) {
    account = (extno) || '';
    const config = {
      uri: `${extno}@${ws_address}`,
      wsServers: `wss://${ws_address}:${ws_port}`,
      // usePreloadedRoute: true,
      authorizationUser: extno,
      password: extpass,
      allowLegacyNotifications: true,
      stunServers: ['stun:stun.freeswitch.org:3478'],
      autostart: true,
      register: false,
      iceCheckingTimeout: 500,
      rel100: SIP.C.supported.SUPPORTED,
      traceSip: false,
      log: {
        level: 'error'
		    }
    };
    softPhoneUA = new SIP.UA(config);
    softPhoneUA.on('invite', (session) => {
      SipjsSoftPhone.status.callIn();
      currentSession = session;
      SipjsSoftPhone.sessionEvent(session);
      console.warn('invite');
    });
    softPhoneUA.on('connecting', (args) => {
      console.log('connecting');
    });
    softPhoneUA.on('connected', () => {
      if (softPhoneUA.isRegistered()) {
        SipjsSoftPhone.status.ready();
        console.warn('connected1');
      } else {
        console.warn('connected2');
        SipjsSoftPhone.status.notready();
      }
    });
    softPhoneUA.on('unregistered', (response, cause) => {
      console.warn('unregistered');
      SipjsSoftPhone.status.notready();
    });
    softPhoneUA.on('registered', (data) => {
      SipjsSoftPhone.status.ready();
    });
    softPhoneUA.on('registrationFailed', (response, cause) => {
      console.log(`register failed .....${response}`);
    });
    softPhoneUA.on('disconnected', () => {
      SipjsSoftPhone.status.logout();
    });
    SipjsSoftPhone.status.login();
    const mediaConstraints = {
      audio: true,
      video: false
    };
  },

  // 注册
  ready() {
    softPhoneUA.register({ register: true });
  },
  // 取消注册
  notready() {
    softPhoneUA.unregister();
  },
  // 登出
  logout() {
    softPhoneUA.stop({ register: true });
  },

  invite(pnumber) {
    called = pnumber;
    currentSession = softPhoneUA.invite(`${pnumber}@${ws_address}`, SipjsSoftPhone.getOptions());
    SipjsSoftPhone.sessionEvent(currentSession);
    SipjsSoftPhone.status.callOut();
  },

  answer() {
    if (currentSession) {
      currentSession.accept(SipjsSoftPhone.getOptions());
    }
  },

  hangup() {
    if (currentSession) {
      if (currentSession.hasAnswer) {
        currentSession.bye();
      } else if (currentSession.isCanceled == false) {
        currentSession.cancel();
      } else {
        currentSession.reject();
      }
    }
  },

  hold() {
    if (currentSession && currentSession.hasAnswer) {
      currentSession.hold();
    }
  },

  unhold() {
    if (currentSession && currentSession.hasAnswer) {
      currentSession.unhold();
    }
  },

  sessionEvent(session) {
    session.on('rejected', (response, cause) => {
      SipjsSoftPhone.status.hungup();
    });
    session.on('bye', (response, cause) => {
      SipjsSoftPhone.status.hungup();
    });
    session.on('cancel', (response, cause) => {
      SipjsSoftPhone.status.hungup();
    });
    session.on('hold', (response, cause) => {
      SipjsSoftPhone.status.hold();
    });
    session.on('unhold', (response, cause) => {
      SipjsSoftPhone.status.unhold();
    });
    session.on('accepted', (response, cause) => {
      SipjsSoftPhone.status.accepted();
    });
    SipjsSoftPhone.status.initCallStatus(session, called);
  },

  status: {
    login() {
      setButtonUseable('register');
      setButtonDisabled('unregister');
      setButtonDisabled('makecall');
      setButtonDisabled('answer');
      setButtonDisabled('hold');
      setButtonDisabled('unhold');
      setButtonDisabled('hangup');

      setButtonDisplayBlock('register');
      setButtonDisplayNone('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');


      document.getElementById('callstate').innerHTML = '未登录';
      document.getElementById('agentnumber').innerHTML = '&nbsp;';
      console.warn('未登录');
    },
    ready() {
      setButtonDisabled('register');
      setButtonUseable('unregister');
      setButtonUseable('makecall');
      setButtonDisabled('answer');
      setButtonDisabled('hold');
      setButtonDisabled('unhold');
      setButtonDisabled('hangup');

      setButtonDisplayNone('register');
      setButtonDisplayBlock('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');

      document.getElementById('callstate').innerHTML = '已注册';
      document.getElementById('agentnumber').innerHTML = account;
      console.warn('已注册');
    },
    notready() {
      setButtonUseable('register');
      setButtonDisabled('unregister');
      setButtonDisabled('makecall');
      setButtonDisabled('answer');
      setButtonDisabled('hold');
      setButtonDisabled('unhold');
      setButtonDisabled('hangup');

      setButtonDisplayBlock('register');
      setButtonDisplayNone('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');

      document.getElementById('callstate').innerHTML = '未注册';
      document.getElementById('agentnumber').innerHTML = '';
      console.warn('未注册');
    },
    hungup() {
      setButtonDisabled('register');
      setButtonUseable('unregister');
      setButtonUseable('makecall');
      setButtonDisabled('answer');
      setButtonDisabled('hold');
      setButtonDisabled('unhold');
      setButtonDisabled('hangup');

      setButtonDisplayNone('register');
      setButtonDisplayBlock('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');

      called = '';
      document.getElementById('callstate').innerHTML = '已注册';
      console.warn('挂断');
      $('#called').show();
      $('#dialing').hide();
      $('#calling').hide();
      // 关闭弹框
      closeCallDialog();
    },
    accepted(response, cause) {
      setButtonDisabled('register');
      setButtonDisabled('unregister');
      setButtonDisabled('makecall');
      setButtonDisabled('answer');
      setButtonUseable('hold');
      setButtonDisabled('unhold');
      setButtonUseable('hangup');

      setButtonDisplayNone('register');
      setButtonDisplayBlock('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');

      document.getElementById('callstate').innerHTML = '通话中';
      console.warn('通话中');
      $('#calling').show();
      $('#dialing').hide();
    },
    hold() {
      setButtonDisabled('register');
      setButtonDisabled('unregister');
      setButtonDisabled('makecall');
      setButtonDisabled('answer');
      setButtonDisabled('hold');
      setButtonUseable('unhold');
      setButtonUseable('hangup');

      setButtonDisplayNone('register');
      setButtonDisplayBlock('unregister');
      setButtonDisplayNone('hold');
      setButtonDisplayBlock('unhold');

      document.getElementById('callstate').innerHTML = '保留中';
      console.warn('保留中');
    },
    unhold() {
      setButtonDisabled('register');
      setButtonDisabled('unregister');
      setButtonDisabled('makecall');
      setButtonDisabled('answer');
      setButtonUseable('hold');
      setButtonDisabled('unhold');
      setButtonUseable('hangup');

      setButtonDisplayNone('register');
      setButtonDisplayBlock('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');

      document.getElementById('callstate').innerHTML = '通话中';
      $('#calling').show();
      $('#dialing').hide();
    },
    callIn() {
      setButtonDisabled('register');
      setButtonDisabled('unregister');
      setButtonDisabled('makecall');
      setButtonUseable('answer');
      setButtonDisabled('hold');
      setButtonDisabled('unhold');
      setButtonUseable('hangup');

      setButtonDisplayNone('register');
      setButtonDisplayBlock('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');

      document.getElementById('callstate').innerHTML = '来电振铃';
      console.warn('来电振铃');
    },
    callOut() {
      setButtonDisabled('register');
      setButtonDisabled('unregister');
      setButtonDisabled('makecall');
      setButtonDisabled('answer');
      setButtonDisabled('hold');
      setButtonDisabled('unhold');
      setButtonUseable('hangup');

      setButtonDisplayNone('register');
      setButtonDisplayBlock('unregister');
      setButtonDisplayBlock('hold');
      setButtonDisplayNone('unhold');

      document.getElementById('callstate').innerHTML = '呼叫';
      console.warn('呼叫');
    },
    initCallStatus(session, called) {
      if (called) {
        document.getElementById('callnumber').innerHTML = called;
      } else {
        document.getElementById('callnumber').innerHTML = session.request.from.uri.user;
      }
    }
  }
};

// 初始化
function install() {
  setParam();
  // SipjsSoftPhone.login(account, password);
  SipjsSoftPhone.login('1001', 'hualaicallcenter');

  document.getElementById('register').addEventListener('click', () => {
    console.warn('111')
    SipjsSoftPhone.ready();
  }, false);

  document.getElementById('unregister').addEventListener('click', () => {
    SipjsSoftPhone.notready();
  }, false);

  document.getElementById('makecall').addEventListener('click', () => {
    const callnum = document.getElementById('tel_num').value.replace(/\s/g, '');
    SipjsSoftPhone.invite(callnum);
  }, false);

  document.getElementById('answer').addEventListener('click', () => {
    SipjsSoftPhone.answer();
  }, false);

  document.getElementById('hold').addEventListener('click', () => {
    SipjsSoftPhone.hold();
  }, false);

  document.getElementById('unhold').addEventListener('click', () => {
    SipjsSoftPhone.unhold();
  }, false);

  document.getElementById('hangup').addEventListener('click', () => {
    SipjsSoftPhone.hangup();
  }, false);
}

export default (Vue) => {
  // 初始化
  Vue.prototype.$install = install;
  
  Vue.prototype.$setParam = setParam;

  // 签入
  Vue.prototype.$registerButton = registerButton;
  
  // 呼叫
  Vue.prototype.$makecallButton = makecallButton;

  // 挂机
  Vue.prototype.$hangupButton = hangupButton;
};


// WEBPACK FOOTER //
// ./src/utils/ua.js